"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbsSecondaryContainerMultipleRows = void 0;
var _react = _interopRequireDefault(require("react"));
var _Grid = require("../../../../base-components/Grid/Grid");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SbsSecondaryContainerMultipleRows = exports.SbsSecondaryContainerMultipleRows = function SbsSecondaryContainerMultipleRows(_ref) {
  var styles = _ref.styles,
    title = _ref.title,
    TitleComponent = _ref.TitleComponent,
    subtitle = _ref.subtitle,
    welcomeOffer = _ref.welcomeOffer,
    rows = _ref.rows,
    gridStyles = _ref.gridStyles;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.gridWrapper
  }, /*#__PURE__*/_react["default"].createElement(TitleComponent, {
    className: styles.title
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.subtitle
  }, subtitle), welcomeOffer && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.welcomeOffer
  }, welcomeOffer), (rows || []).map(function (_ref2) {
    var content = _ref2.content;
    return /*#__PURE__*/_react["default"].createElement(_Grid.Grid, {
      styles: gridStyles,
      type: "row",
      className: styles.contentRow
    }, content.map(function (d, i) {
      var leftKey = "left-".concat(i);
      var rightKey = "right-".concat(i);
      return [/*#__PURE__*/_react["default"].createElement(_Grid.Grid, {
        styles: gridStyles,
        key: leftKey,
        type: d.leftCellSize,
        className: styles.leftCell
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.content
      }, d.leftCell)), /*#__PURE__*/_react["default"].createElement(_Grid.Grid, {
        styles: gridStyles,
        key: rightKey,
        type: d.rightCellSize,
        className: styles.rightCell
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.content
      }, d.rightCell))];
    }));
  }));
};
SbsSecondaryContainerMultipleRows.propTypes = {
  gridStyles: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  styles: _propTypes["default"].shape({
    gridWrapper: _propTypes["default"].string,
    title: _propTypes["default"].string,
    subtitle: _propTypes["default"].string,
    contentRow: _propTypes["default"].string,
    leftCell: _propTypes["default"].string,
    rightCell: _propTypes["default"].string,
    content: _propTypes["default"].string
  }),
  title: _propTypes["default"].node,
  TitleComponent: _propTypes["default"].string,
  subtitle: _propTypes["default"].node,
  rows: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    content: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      leftCell: _propTypes["default"].node,
      leftCellSize: _propTypes["default"].node,
      rightCell: _propTypes["default"].node,
      rightCellSize: _propTypes["default"].node
    }))
  })),
  welcomeOffer: _propTypes["default"].string
};
SbsSecondaryContainerMultipleRows.defaultProps = {
  styles: {},
  title: '',
  TitleComponent: 'h1',
  subtitle: '',
  welcomeOffer: '',
  rows: []
};